
import * as api from '../../services/currency/api_currency';
import * as apiCommon from '../../services/apiCommon';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as SagaCommon from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';

export function* fetchListCurrencySaga(feathersApp) {
    yield takeLatest('FETCH_LIST_CURRENCY', callFetchListCurrency, feathersApp);
}

function* callFetchListCurrency(feathersApp, action) {
    const { silent, filters } = action;
    yield SagaCommon.showProgressListTable(silent);
    try {
        const dataParams = {
            filters,
            list_type: 'currency'
        };
        const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
        yield call(SagaCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total });
    } catch (error) {
        yield SagaCommon.showErrorListTable(error);
    }
}


export function* saveCurrencySaga(feathersApp) {
    yield takeEvery("SAVE_CURRENCY", callSaveCurrency, feathersApp);
}
function* callSaveCurrency(feathersApp, action) {
    yield SagaCommon.showProgressSaveRecord();
    const { tenant, user } = yield select();
    try {
        const result = yield call(api.saveCurrency, feathersApp, {
            tenant,
            user,
            data: action.data
        });
        const id = result && result.id;
        if (id) {
            yield callFetchCurrencyForEdit(feathersApp, { id, silent: true });
            browserHistory.push(`/admin/currency/edit/${result.id}`);
            yield SagaCommon.doneSaveRecord(result, "Currency was saved");
        } else {
            yield SagaCommon.showErrorSaveRecord(new Error('Error in saving : Currency'));
        }
    } catch (error) {
        yield SagaCommon.showErrorSaveRecord(error);
    }
}

export function* deleteCurrencyFromListSaga(feathersApp) {
    yield takeEvery('DELETE_CURRENCY_FROM_LIST', callDeleteCurrencyFromList, feathersApp);
}

function* callDeleteCurrencyFromList(feathersApp, action) {
    yield deleteCurrency(feathersApp, action);
    yield delay(2000);
    yield callFetchListCurrency(feathersApp, { silent: true });
}

function* deleteCurrency(feathersApp, action) {
    yield SagaCommon.showProgressDeleteRecord();
    try {
        const { id } = action;
        let result = null;
        if (id) {
            const state = yield select();
            const { tenant, user } = state;
            const params = { tenant, user, id };
            result = yield call(api.deleteCurrency, feathersApp, params);
            yield SagaCommon.doneDeleteRecord(id, 'currency');
        }

        return result;
    } catch (error) {
        yield SagaCommon.showErrorDeleteRecord(error);
    }
}

export function* deleteCurrencySaga(feathersApp) {
    yield takeEvery('DELETE_CURRENCY', callDeleteCurrency, feathersApp);
}

function* callDeleteCurrency(feathersApp, action) {
    let result = yield deleteCurrency(feathersApp, action);
    yield delay(2000);
    if (result) {
        browserHistory.push('/admin/currency');
    }
}


export function* fetchCurrencyForEditSaga(feathersApp) {
    yield takeEvery('FETCH_CURRENCY_BY_ID', callFetchCurrencyForEdit, feathersApp);
}
function* callFetchCurrencyForEdit(feathersApp, action) {
    const { tenant, user } = yield select();
    const { id } = action;
    const docType = DocType.CURRENCY;
    try {
        yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
        if (id) {
            const fetchParams = { tenant, user, id };
            let doc = yield call(api.fetchCurrencyById, feathersApp, fetchParams);
            yield SagaCommon.doneDataById(doc);
        } else {
            yield SagaCommon.doneDataById({
                active: true
            });
        }
    } catch (error) {
        yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
    }
}